type AccountId = string | number | null | undefined

/** The identifier shown in the "ID" column of the connected-accounts table. */
export function accountDisplayId(account: any): AccountId {
  switch (account?.channel) {
    case 'eBay':
      return account.ebay_user_id || account.id || account.merchant_id
    case 'Woocommerce':
    case 'Facebook Ads':
      return account.merchant_id
    case 'Google Ads':
      return account.google_ads_account_id ?? account.merchant_id
    case 'Makeswift':
      return account.account_name || account.account_email || account.merchant_id
    default:
      return account?.account_name || account?.merchant_id
  }
}

export function accountEmail(account: any): string {
  return String(account?.account_email || account?.email || '').trim()
}

/**
 * Label for an account in a picker. Teams often connect many stores under one
 * login, so lead with the ID and only add the email when it disambiguates.
 */
export function accountPickerLabel(account: any, index: number, includeEmail = false): string {
  const id = String(accountDisplayId(account) ?? '').trim()
  const email = accountEmail(account)

  if (id && includeEmail && email && email !== id) return `${id} (${email})`
  return id || email || `Account ${index + 1}`
}

/** True when the accounts differ by email, so showing it in a picker adds information. */
export function accountEmailsDiffer(accounts: any[]): boolean {
  const emails = new Set(accounts.map(accountEmail).filter(Boolean))
  return emails.size > 1
}

export function isSameAccount(a: any, b: any): boolean {
  if (!a || !b) return false
  if (a === b) return true
  if (a._keyId && b._keyId) return String(a._keyId) === String(b._keyId)
  if (String(a.channel ?? '') !== String(b.channel ?? '')) return false
  const idA = String(accountDisplayId(a) ?? '').trim()
  const idB = String(accountDisplayId(b) ?? '').trim()
  if (idA && idB) return idA === idB
  return Boolean(a.merchant_id) && String(a.merchant_id) === String(b.merchant_id)
}
